import { useEffect } from "react";
import CustomerPageLayout from "../customer-page-layout/CustomerPageLayout";
import { CallCenterIcon, ChatIcon } from "../../../assets/icons";
import { SelectableItem } from "../../../common/components/selectable-item/SelectableItem";
import { CardFrame } from "../../../common/components/card-frame/CardFrame";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ApplicationRoutes } from "../../../routes";
import { useSalesIQ } from "../../../hooks/useSalesIQ";
import { useGetZohoSaleConfigurationQuery } from "../../../service/zoho-sale-service";
import { salesIQService } from "../../../services/salesIQ/salesIQ-service";
import Can from "../../../guards/Can";
import { CustomerPermissions } from "../../../model/permissions/permissions";

export const SupportPage = () => {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const { openChat } = useSalesIQ();
	const { data: zohoConfig } = useGetZohoSaleConfigurationQuery();

	// Load the tenant's SalesIQ widget only once its code is fetched.
	useEffect(() => {
		if (zohoConfig?.widgetCode) {
			salesIQService.init(zohoConfig.widgetCode);
		}
	}, [zohoConfig?.widgetCode]);

	return (
		<CustomerPageLayout title={t("common.support")} onBack={() => navigate(-1)} >
			<CardFrame>
				{zohoConfig?.widgetCode && (
					<Can permission={CustomerPermissions.ChatCustomerSupport}>
						<SelectableItem leftIcon={<ChatIcon />} title={t("support.supportChatTitle")} subtitle={t("support.supportChatSubtitle")} onClick={openChat} />
					</Can>
				)}
				<SelectableItem
					leftIcon={<CallCenterIcon />}
					title={t("support.supportCallCenterTitle")}
					subtitle={t("support.supportCallCenterSubtitle")}
					showBadge
					hideBottomBorder
					onClick={() => navigate(ApplicationRoutes.CUSTOMER_CALL_CENTER)}
				/>
			</CardFrame>
		</CustomerPageLayout>
	);
};
